import { parse, isToday } from "date-fns";
import { pl } from "date-fns/locale";
import { getArticleList } from "../../api/api";
import ArticlesBrief from "../../pages/ArticlesBrief";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/(app)/_app/articles-brief")({
	component: ArticlesBrief,
	loader: async () => {
		const articles = await getArticleList({}, 1, 10);
		
		// Filter articles by today's date using Polish date format
		const filteredPosts = articles.posts.filter((article) => {
			try {
				// Parse Polish date format "9 lipca, 2025" to Date object
				const articleDate = parse(article.date, "d MMMM, yyyy", new Date(), {
					locale: pl,
				});
				
				// Check if the parsed date is today
				return isToday(articleDate);
			} catch (error) {
				console.error("Error parsing date:", article.date, error);
				return false;
			}
		});
		console.log("filteredArticles", filteredPosts);
		return {
			posts: filteredPosts,
		};
	},
});
